import axios, { AxiosInstance } from 'axios';
import client from './RestClient';

export interface GCSWebService {
  uploadFileToCloudByPresignedUrl (file: File, bucket: string): Promise<string>;
}

export class RestfulGCSWebService implements GCSWebService {

  constructor (
    private restClient: AxiosInstance = axios,
    private pmaxRestClient: AxiosInstance = client
  ) {}

  async uploadFileToCloudByPresignedUrl (file: File, bucket: string) {
    // prevent file name include specific sign: #, &,/,=
    const splitFileName = file.name.split('.');
    const extension = splitFileName.length > 1 ? splitFileName.pop() : 'png';
    const fileName = `file-${new Date().getTime()}.${extension}`;
    const res = await this.pmaxRestClient.get(`/v2/creatives/create-file-url?bucket=${bucket}&fileName=${fileName}&contentType=${file.type}`);
    const presignedUrl = res.data.url;
    await this.restClient.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type
      }
    });
    return presignedUrl.split('?')[0];
  }
}
